import { get } from './index';
export const getThemes = () => get('/themes');
